import type { QueryHookOptions } from "@apollo/client";
import { useQuery, gql } from "@apollo/client";

const Health_Conditions_Shared_Query = gql`
  query Health_Conditions_Shared_Query {
    viewer {
      healthConditions {
        id
        name
      }
    }
  }
`;

interface HealthConditionsData {
  viewer: {
    healthConditions: {
      id: string;
      name: string;
    }[];
  };
}

const useHealthConditionsQuery = (options?: QueryHookOptions<HealthConditionsData>) => {
  return useQuery<HealthConditionsData>(Health_Conditions_Shared_Query, options);
};

export type { HealthConditionsData };

/* eslint-disable @fullscript/gql-no-manual-hook-declaration */
export { useHealthConditionsQuery, Health_Conditions_Shared_Query };
